export default function getFontFromVariant(variant: string, weight: string): string {
  if (variant === 'base') return 'Graphik, Helvetica, sans-serif';

  const fonts = {
    normal: 'SourceCodePro-Regular',
    medium: 'SourceCodePro-Medium',
    default: 'SourceCodePro-Semibold'
  };

  const fallbacks = 'SFMono-Regular, Menlo, Monaco, Consolas, monospace';

  return fonts[weight] ? `${fonts[weight]}, ${fallbacks}` : `${fonts.default}, ${fallbacks}`;
}
